import _ from 'underscore';

import { ExplorableItemType, SpaceInfoItemType } from '~src/spacesPlatform/models/ContentType';
import { INamedItem } from '~src/spacesPlatform/models/resourceParts';
import { IView } from '~src/views/ServerApi/types/IView';

import { IAccelerationRecommendation } from '../../serverApi/types/IAccelerationRecommendation';
import { IAccelerationRecommendationInfo } from '../IAccelerationRecommendationInfo';

export module AccelerationRecommendationMapper {

  export function map(
    recommendations: IAccelerationRecommendation[],
    views: _.Dictionary<IView>,
    workbooks: _.Dictionary<INamedItem>,
    projects: _.Dictionary<INamedItem>
  ): IAccelerationRecommendationInfo[] {

    // If there are no recommendations return an empty array
    if (recommendations.length === 0) {
      return [];
    }

    var lastMonthViewCountMax = 0;
    Object.values(views).forEach(view =>
      lastMonthViewCountMax = Math.max(lastMonthViewCountMax, view.usageInfo.hitsLastOneMonthTotal));

    return _.map(recommendations, (recommendation: IAccelerationRecommendation) => {
      return {
        id: recommendation.viewId,
        contentType: 'performance' as ExplorableItemType,
        name: views[recommendation.viewId].name,
        luid: views[recommendation.viewId].luid,
        workbook: workbooks[recommendation.workbookId],
        project: projects[recommendation.projectId],
        view: { ...views[recommendation.viewId], contentType: 'view' as SpaceInfoItemType},
        lastMonthViewCount: views[recommendation.viewId].usageInfo.hitsLastOneMonthTotal,
        avgQueryBatchTime: recommendation.avgQueryBatchTime || 0,
        requestsToAccelerate: recommendation.requestsToAccelerate || 0,
        rank: recommendation.rank || 0,
      };
    });
  }
}
